import React, { useEffect } from 'react';
import MainStore from './MainStore';

export default function useDataEvent(fields, ids, callback){
    const callbackId = React.useRef(null)
    const latestCallback = React.useRef(callback)
    const [count, forceUpdate] = React.useReducer( (x)=>x+1, 0)

    React.useEffect(()=>{
        latestCallback.current = callback
    }, [callback])

    const wrap = React.useCallback((...args)=>{
        let doUpdate = true
        if( latestCallback.current ){
            const r = latestCallback.current(...args)
            if( r === false){
                doUpdate = false
            }
        }
        if( doUpdate ){
            forceUpdate()
        }
    }, [])

    React.useEffect(()=>{
        if( fields ){
            callbackId.current = MainStore().registerCallback(callbackId.current, fields, wrap, ids )
            return ()=>{
                MainStore().deregisterCallback(callbackId.current )
            }
        }
    }, [fields, ids, wrap])

    return callbackId
}
